import React from "react";
import ArticlePage from "../ArticlePage";

const MusicRoundup = () => (
  <ArticlePage
    title="Music Roundup"
    subtitle="Music"
    leadImage="/img/culture/music_.jpg"
    body={[
      "Where we're following the music beat this cycle \u2014 charts, label ecosystems and independent hip-hop coverage. Each box links out to the publisher's own coverage.",
    ]}
    sources={[
      {
        brand: "Billboard",
        title: "Charts, artist news and album reviews",
        host: "billboard.com",
        href: "https://www.billboard.com",
        accent: "#f04d24",
      },
      {
        brand: "AWGE",
        title: "A$AP Mob\u2019s creative agency and label",
        host: "awge.com",
        href: "https://awge.com",
        accent: "#000000",
      },
      {
        brand: "XXL Magazine",
        title: "Freshmen, features and long-form hip-hop reporting",
        host: "xxlmag.com",
        href: "https://www.xxlmag.com",
        accent: "#d8a24a",
      },
    ]}
  />
);

export default MusicRoundup;
